/**
 * SMS tab Placement Recruiter chips — replicates My Candidates - Retention chip.
 * Shows "Placement Recruiter : [name] ×" when recruiter is selected.
 */
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ChipsContainer } from 'app/ComponentLibrary/Filter';
import { HIDE_RECRUITER_FILTER_FOR_SMS } from './DashboardRetentionFilterUtils';

export interface DashboardSmsRecruiterChipsProps {
  onApplyFilter: (values: Record<string, unknown>) => void;
  /** Hide Placement Recruiter chip; show only Phone. Default from HIDE_RECRUITER_FILTER_FOR_SMS. */
  hideRecruiterFilter?: boolean;
}

export const DashboardSmsRecruiterChips: React.FC<DashboardSmsRecruiterChipsProps> = ({
  onApplyFilter,
  hideRecruiterFilter = HIDE_RECRUITER_FILTER_FOR_SMS,
}) => {
  const { getValues, setValue, watch } = useFormContext();
  const placementRecruiter = watch('placementRecruiter');
  const senderPhoneNumber = watch('senderPhoneNumber');

  const recruiter = Array.isArray(placementRecruiter)
    ? placementRecruiter[0]
    : placementRecruiter && typeof placementRecruiter === 'object'
      ? placementRecruiter
      : null;

  const chips = React.useMemo(() => {
    const result: Record<string, { label: string; enableDelete: boolean; value: unknown }[]> = {};
    if (!hideRecruiterFilter && recruiter?.name) {
      result.placementRecruiter = [
        { label: `Placement Recruiter : ${recruiter.name}`, enableDelete: true, value: recruiter },
      ];
    }
    if (senderPhoneNumber && String(senderPhoneNumber).trim()) {
      result.senderPhoneNumber = [
        { label: `Phone : ${senderPhoneNumber}`, enableDelete: true, value: senderPhoneNumber },
      ];
    }
    return result;
  }, [recruiter, senderPhoneNumber, hideRecruiterFilter]);

  const handleChipDelete = (field: string) => {
    const values = getValues();
    if (field === 'placementRecruiter') {
      setValue('placementRecruiter', null);
      onApplyFilter({ ...values, placementRecruiter: null });
    } else if (field === 'senderPhoneNumber') {
      setValue('senderPhoneNumber', '');
      onApplyFilter({ ...values, senderPhoneNumber: '' });
    }
  };

  if (Object.keys(chips).length === 0) return null;

  return <ChipsContainer chips={chips} onClick={() => {}} onDelete={handleChipDelete} />;
};
